import React from 'react';

const CouponError = () => (
  <div>
    {'Votre commande n\'a pas pu aboutir : le coupon indiqué n\'est pas valable'}
  </div >
);

export default CouponError;